( function( $ ) {

    $(document).ready(function() {
        AOS.init();
    })

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('.js-hMenu').slideToggle();
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        $(this).toggleClass('clicked');
        $(this).siblings('.sub-menu').slideToggle()
    });
    /*header menu*/

    /*modal contact*/
    $('.js-contBtn, a[href="#contact_modal"]').click(function(e){
        e.preventDefault();
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*modal contact*/

    /*video*/
    $(document).ready(function () {
        const player = $('#vimeo-player')[0];
        $('.js-firstLoud').on('click', function () {
            const $this = $(this);
            player.muted = !player.muted;
            $this.find('.sound').removeClass('active');
            if (player.muted) {
                $this.find('.sound[data-sound="disabled"]').addClass('active');
            } else {
                $this.find('.sound[data-sound="enabled"]').addClass('active');
            }
        });
    });
    /*video*/

    /*main-vals*/
    $(window).on('load resize', function () {

        if ($(window).width() > 991) {

            if ($('.js-mainValsSlider').hasClass('slick-initialized')) {
                setTimeout(function(){$('.js-mainValsSlider').slick('unslick');}, 200)
            }

        } else {
            if (!$('.js-mainValsSlider').hasClass('slick-initialized')) {
                $('.js-mainValsSlider').slick({
                    arrows: true,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 2,
                    prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M19 12H5" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 19L5 12L12 5" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                    nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5 12H19" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 5L19 12L12 19" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                    appendArrows: $('.js-mainValsSliderArrows'),
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        }
    });
    /*main-vals*/

    /*main-line*/
    $(document).ready(function() {
        $('.js-mainLine').marquee({
            duration: ($(window).width() > 991) ? 25000 : 40000,
            gap: 0,
            delayBeforeStart: 0,
            direction: 'left',
            startVisible: true,
            duplicated: true,
            duplicateCount: 2
        });
    });
    /*main-line*/

    /*main-traits*/
    $(window).on('load resize', function () {

        var mainTraitsBlHov = false;
        if ($(window).width() > 991) {
            if (!mainTraitsBlHov) {
                $('.main-traits-bl').mouseover(function(){
                    $('.main-traits-bl').removeClass('hover');
                    mainTraitsBlHov = true;
                })
            }

            if ($('.js-mainTraitsSlider').hasClass('slick-initialized')) {
                setTimeout(function(){$('.js-mainTraitsSlider').slick('unslick');}, 200)
            }

        } else {

            if (!$('.js-mainTraitsSlider').hasClass('slick-initialized')) {

                $('.js-mainTraitsSlider').slick({
                    arrows: true,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 2,
                    appendArrows: $('.js-mainTraitsSliderArrows'),
                    prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M19 12H5" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 19L5 12L12 5" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                    nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5 12H19" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 5L19 12L12 19" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });

            }

        }

    });
    /*main-traits*/

    /*main-labs*/
    $(window).on('scroll resize', function () {
        if ($(window).width() > 991) {
            const $section = $('.js-mainLabs');
            if ($section.length > 0) {
                const sectionTop = $section.offset().top;

                const viewportBottom = $(window).scrollTop() + $(window).height();

                const offset = 100;

                if (viewportBottom > sectionTop + offset) {
                    $section.addClass('animated');
                } else {
                    $section.removeClass('animated');
                }
            }
        }
    });

    $(window).trigger('scroll');
    /*main-labs*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/



    /*tax_trait*/
    $(document).ready(function () {
        if ($(window).width() <= 991) {
            $('.js-taxTraitSlider').slick({
                arrows: true,
                dots: false,
                centerMode: false,
                slidesToShow: 2,
                prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M19 12H5" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 19L5 12L12 5" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5 12H19" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 5L19 12L12 19" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
                appendArrows: $('.js-taxTraitSliderArrows'),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    });
    /*tax_trait*/


    /*scroll sidebar*/
    $(window).on('load resize', function(){
        if ($('.js-pageTextSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageTextSide').offset().top;
                var singleSidebarRailTop = $('.js-pageTextSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageTextSide').outerHeight();
                var singleSidebarMenuH = $('.js-pageTextSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageTextSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageTextSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageTextSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-pageTextSideRail').css('height', 'auto')
            }
        }
    })
    /*scroll sidebar*/

    /*page cons*/
    $('.js-pageConsTerm').click(function(){
        if (!$(this).hasClass('active')) {
            var id = $(this).data('id');

            if ($(window).width() > 991) {
                $('.js-pageConsCol').addClass('pc_hidden');
                $('.js-pageConsCol[data-id="'+id+'"]').removeClass('pc_hidden');
            }

            $('.js-pageConsTerm').removeClass('active')
            $(this).addClass('active')
        }
    })
    /*page cons*/




    /*page faq*/
    $('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')


        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
        $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
    })
    /*page faq*/

    /*page cabinet*/

    $(document).ready(function() {
        var pagecabinetGalDir = 'left';
        if ($(window).width() > 991) {
            if ($('.js-pageCabinetGal').length > 0) {
                $('.js-pageCabinetGal').each(function (i) {
                    console.log(pagecabinetGalDir);
                    $(this).marquee({
                        startVisible: true,
                        duration: 25000,
                        gap: 0,
                        delayBeforeStart: 0,
                        direction: pagecabinetGalDir,
                        duplicated: true,
                        duplicateCount: 3,
                        pauseOnHover: true
                    });
                    if (pagecabinetGalDir === 'left') {
                        pagecabinetGalDir = 'right';
                    } else {
                        pagecabinetGalDir = 'left';
                    }
                });
            }
        }

        $('.js-pageCabinetGalModalSlider').slick({
            arrows: true,
            dots: false,
            centerMode: false,
            slidesToShow: 1,
            prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M19 12H5" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 19L5 12L12 5" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5 12H19" stroke="#D02F5C" stroke-linecap="round"/> <path d="M12 5L19 12L12 19" stroke="#D02F5C" stroke-linecap="round"/> </svg></button>',
        });
        $('.js-pageCabinetGalSliderImg').click(function () {
            $('.js-pageCabinetGalModalSlider').slick('slickGoTo', $(this).data('img'));
            $('.js-pageCabinetGalModal').addClass('active');
        })

        $('.js-pageCabinetGalModalCls').click(function () {
            $('.js-pageCabinetGalModal').removeClass('active');
            setTimeout(function () {
                $('.js-pageCabinetGalModalImg').html('');
            }, 500)
        })
    });
    /*page cabinet*/

}( jQuery ) );
